import { render, staticRenderFns } from "./Mentorias.vue?vue&type=template&id=f8cdc9e0&scoped=true&"
import script from "./Mentorias.vue?vue&type=script&lang=js&"
export * from "./Mentorias.vue?vue&type=script&lang=js&"
import style0 from "./Mentorias.vue?vue&type=style&index=0&id=f8cdc9e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdc9e0",
  null
  
)

export default component.exports